import api from "../../../services/api";

const getGrade = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/master_grade").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTGRADE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const cost_center = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/cost_center").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTCOSTCENTER", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getWorkLocation = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/work_location").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTWORKLOCATION", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getKaryawanById = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/karyawan/" + state.idUser).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESUTKARYAWAN", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getKaryawanById2 = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.get("/karyawan/2/" + state.idUser).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESUTKARYAWAN", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getKaryawanById2New = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    api.get("/karyawan/2/" + id).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESUTKARYAWAN", res.data);
          return res.data;
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getEmpNo = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api
      .get("/master/generate/karyawan", {
        params: {
          join_date: state.params
        }
      })
      .then(
        response => {
          const res = response.data;
          resolve(response);
          if (res.status) {
            commit("SET_RESEMP", res.data);
          }
        },
        error => {
          reject(error);
        }
      );
  });
};
const getCekUsername = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/cek/username/" + state.username).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESCEKUSER", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getReligions = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/religions").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESRELIGIONS", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMaritalStatus = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/marital_status").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_MARITAL", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getTaxStatus = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/tax_status").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_TAX_DLL", res.data);
          console.log(res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getResignType = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/resign").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESIGNTYPE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};

const getMasterRole = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/rolemaster/").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESULTROLE", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
export default {
  getTaxStatus,
  getGrade,
  cost_center,
  getWorkLocation,
  getKaryawanById,
  getCekUsername,
  getReligions,
  getMaritalStatus,
  getResignType,
  getMasterRole,
  getKaryawanById2,
  getEmpNo,
  getKaryawanById2New
};
